import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";
import BaseService from "./base.service";

export default class GalleryContentService extends BaseService {
  search = (params) => {
    const searchParams = new URLSearchParams();
    Object.keys(params || {}).forEach((key) => {
      const value = params[key];
      if (value === null || value === undefined || value === "") {
        return;
      }
      if (Array.isArray(value)) {
        if (value.length === 0) {
          return;
        }
        value.forEach((item) => {
          if (item !== null && item !== undefined && item !== "") {
            searchParams.append(key, item);
          }
        });
        return;
      }
      searchParams.append(key, value);
    });
    return this.axios.get(API_ENDPOINTS.GALLERY_CONTENT_SEARCH, {
      params: searchParams,
    });
  };

  getDetail = ({ galleryContentStoreId }) => {
    return this.axios.get(
      API_ENDPOINTS.GALLERY_CONTENT_DETAIL.replace(
        "{galleryContentStoreId}",
        galleryContentStoreId
      )
    );
  };

  register = (data) => {
    return this.axios.post(API_ENDPOINTS.GALLERY_CONTENT_REGISTER, data);
  };

  update = ({ galleryContentStoreId, data }) => {
    return this.axios.put(
      API_ENDPOINTS.GALLERY_CONTENT_UPDATE.replace(
        "{galleryContentStoreId}",
        galleryContentStoreId
      ),
      data
    );
  };

  delete = ({ galleryContentStoreId }) => {
    return this.axios.delete(
      API_ENDPOINTS.GALLERY_CONTENT_DELETE.replace(
        "{galleryContentStoreId}",
        galleryContentStoreId
      )
    );
  };

  getStoresForSelect = () => {
    return this.axios.get(API_ENDPOINTS.GALLERY_CONTENT_STORES_FOR_SELECT);
  };

  execute = (data) => {
    return this.axios.post(API_ENDPOINTS.GALLERY_CONTENT_EXECUTE, data);
  };
}
